import type { Related } from 'src/global-types-2'
import type {
  PersonModel,
  RelationModel,
} from 'src/tpbp-json-api-handler/models/models'
import { RELATION_ROLES } from 'src/services/mappings/relation/relation.const'

export function getRelated(
  relation: RelationModel,
  personId: PersonModel['id'],
) {
  if (personId === relation._subject.id) {
    return {
      relation,
      relationId: relation.id,
      role: relation.inverseRole,
      person: relation._relatedTo,
      from: relation._subject,
    } satisfies Related as Related
  }
  if (personId === relation._relatedTo.id) {
    return {
      relation,
      relationId: relation.id,
      role: relation.role,
      person: relation._subject,
      from: relation._relatedTo,
    } satisfies Related as Related
  }

  throw new Error('Unmanaged case, no related person')
}

export function getRelatedPerson(
  relation: RelationModel,
  personId: PersonModel['id'],
): PersonModel {
  const { person } = getRelated(relation, personId)

  return person
}

export function computePersonFullName(person: PersonModel) {
  return `${person.firstName} ${person.lastName}`
}

export function getPartner(person: PersonModel): PersonModel | undefined {
  const foundRelation = person._relations.find(
    (relation) => relation.role === RELATION_ROLES.partner,
  )
  if (!foundRelation || !person) return

  return getRelatedPerson(foundRelation, person.id)
}
